import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '../../../app.service';
import { NotificationService } from '../../utils/notification.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { config } from '../../smartadmin.config';

declare var $: any;

@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {
  gatemasterIntegration = config.gatemasterIntegration;
  role: string;
  parkCode: string;
  parksWithDisabledAdminRoutes: Array<string>
  constructor(private actr: ActivatedRoute, public appState: AppState, private notificationService: NotificationService,
    private http: HttpClient, private router: Router) {
  }

  ngOnInit() {
    this.role = this.appState.get('role');
    this.parkCode = config.currentPark.code;
    this.parksWithDisabledAdminRoutes = config.parksWithDisabledAdminRoutes
  }

  showPopup() {
    this.notificationService.smartMessageBox({
      title: '<i class=\'fa fa-sign-out txt-color-orangeDark\'></i> Logout <span class=\'txt-color-orangeDark\'><strong>' + $('#show-shortcut').text() + '</strong></span> ?',
      content: 'You can improve your security further after logging out by closing this opened browser',
      buttons: '[No][Yes]'

    }, (ButtonPressed) => {
      if (ButtonPressed === 'Yes') {
        this.logout()
      }
    });
  }

  logout() {
    const headers = new HttpHeaders().set('clientkey', config.API_KEY);
    headers.set('content-type', 'application/json');
    return this.http.get(config.URL + '/session/destroy', { withCredentials: true, headers: headers })
      .subscribe((data) => {
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('authToken');
        this.router.navigate(['/auth/login']);
      }, (err) => {
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('authToken');
        console.log(err);
        this.router.navigate(['/auth/login']);
      })
  }

  sxmNavigation(): boolean {
      return true
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/navigation.component.ts